<div
  class="event"
  (click)="onEventUpdatedClick(event); $event.stopPropagation()"
>
  <ng-container
    [ngTemplateOutlet]="eventTag"
    [ngTemplateOutletContext]="{ overlay: isHover$ | async }"
  />

  <!-- Duplicate component for 'position: absolute' to not broke components positioning-->
  @if (isHover$ | async) {
    <ng-container [ngTemplateOutlet]="eventTag" />
  }
</div>

<ng-template #eventTag let-overlay="overlay">
  <myre-tag
    [type]="eventTagType"
    [customTextColor]="event.customTextColor"
    [customBackgroundColor]="event.customBackgroundColor"
    [class.overlay]="overlay"
  >
    <div class="event__title ellipsis">
      <i class="myre-icon-{{ event.iconName || 'list' }}"></i>
      {{ event.title }}
    </div>
  </myre-tag>
</ng-template>
